"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThumbnailData = exports.getSelectedDesignViewIdentifier = exports.getDesignViewLength = exports.getCurrentDesignView = exports.get2DModelSrc = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _Selectors = require("../Configurator/Selectors");
var _Selectors2 = require("../DesignArea/Selectors");
var _Transformers = require("./Transformers");
var _Transformers2 = require("../DesignArea/Transformers");
var _Selectors3 = require("../ConfigurationMode/Selectors");
var _getImageUrl = _interopRequireDefault(require("../../Utils/getImageUrl"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getThumbnailData = exports.getThumbnailData = function getThumbnailData(state) {
  var items = state.designView.designViews.map(function (designView) {
    var thumbnailImage = state.designView.viewThumbnailImages[designView.identifier];
    return _objectSpread({
      identifier: designView.identifier
    }, thumbnailImage && {
      thumbnailImage: (0, _getImageUrl["default"])(thumbnailImage)
    });
  });
  var dotMode = !items.every(function (item) {
    return item.thumbnailImage;
  });
  var currentConfiguration = (0, _Selectors3.getSelectedConfigurationMode)(state);

  // on designer, we fall back to the older thumbnail images, if they exist
  if (currentConfiguration === 'designer' && dotMode === true) {
    var configuratorState = (0, _Selectors.getConfigurator)(state);
    var itemIdentifier = (0, _Selectors.getSelectedVariantIdentifier)(configuratorState) || (0, _Selectors.getItem)(configuratorState).identifier;
    var designFallBackItems = state.designView.designViews.map(function (designView) {
      var thumbnailImage = (0, _get["default"])(designView.thumbnails, itemIdentifier);
      return _objectSpread({
        identifier: designView.identifier
      }, thumbnailImage && {
        thumbnailImage: (0, _getImageUrl["default"])(thumbnailImage)
      });
    });
    return {
      items: designFallBackItems,
      dotMode: !designFallBackItems.every(function (item) {
        return item.thumbnailImage;
      })
    };
  }
  return {
    dotMode: dotMode,
    items: items
  };
};
var get2DModelSrc = exports.get2DModelSrc = function get2DModelSrc(state, host) {
  var configuratorState = (0, _Selectors.getConfigurator)(state);
  var itemIdentifier = (0, _Selectors.getSelectedVariantIdentifier)(configuratorState) || (0, _Selectors.getItem)(configuratorState).identifier;
  var designArea = (0, _Selectors2.getSelectedDesignArea)(state);
  var designView = designArea && designArea.designView || state.designView.selectedDesignView;
  var src = (0, _get["default"])(designView, "images.".concat(itemIdentifier), null);
  return src ? "".concat(host).concat(src) : null;
};
var getDesignViewLength = exports.getDesignViewLength = function getDesignViewLength(state) {
  return (0, _get["default"])(state.designView.designViews, 'length', 0);
};
var getSelectedDesignViewIdentifier = exports.getSelectedDesignViewIdentifier = function getSelectedDesignViewIdentifier(state) {
  return state.designView.selectedDesignView.identifier;
};

/**
 * Returns the selected design view with the current design area data, or false if not selected
 * @param {{designView: {}, designArea: {}}} state
 * @return {*|{designAreas: *}|boolean}
 */
var getCurrentDesignView = exports.getCurrentDesignView = function getCurrentDesignView(state) {
  var selectedDesignView = state.designView.selectedDesignView;
  if (!selectedDesignView || !selectedDesignView.identifier) {
    return false;
  }
  if (!selectedDesignView.designAreas) {
    return selectedDesignView;
  }
  return _objectSpread(_objectSpread({}, selectedDesignView), {}, {
    designAreas: _toConsumableArray(selectedDesignView.designAreas.map(function (designArea) {
      return (0, _Transformers2.recalculateSingleDesignArea)(state, designArea);
    })).sort(_Transformers.compareDesignAreasBySize)
  });
};